import { WEEKDAYS } from '@/utils/days'

export default {
  methods: {
    weekday(number) {
      return WEEKDAYS[number] || null
    }
  }
}
